/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 *
 ********************************************************************!*/

import { GetterTree } from "vuex";
import { IUserState } from "./state";
import { IRootState } from "@/store/modules/root/state";
import { User } from "firebase/auth";

export enum Getters {
  IS_SIGNED_IN = "IS_SIGNED_IN",
  UID = "UID",
  ID_TOKEN = "ID_TOKEN",
  USER = "USER",
  ORGANIZATION_ID = "ORGANIZATION_ID",
}

export interface IGetters {
  [Getters.IS_SIGNED_IN](state: IUserState): boolean;
  [Getters.UID](state: IUserState): string;
  [Getters.ID_TOKEN](state: IUserState): string;
  [Getters.USER](state: IUserState): User;
  [Getters.ORGANIZATION_ID](state: IUserState): string | undefined;
}

export const getters: GetterTree<IUserState, IRootState> & IGetters = {
  [Getters.IS_SIGNED_IN]: (state: IUserState) => {
    return state.signedIn;
  },
  [Getters.UID]: (state: IUserState) => {
    return state.user.uid;
  },
  [Getters.ID_TOKEN]: (state: IUserState) => {
    return state.idToken;
  },
  [Getters.USER]: (state: IUserState) => {
    return state.user;
  },
  [Getters.ORGANIZATION_ID]: (state: IUserState) => {
    return state?.organization?.id;
  },
};
